//ANIMATIONS
const sr = ScrollReveal({
  distance: '60px',
  duration: 1800,
  delay: 200,
  //reset: true
})

sr.reveal(`.titHero` , {origin: 'left'})
sr.reveal(`#sliderHome` , {origin: 'top'})
sr.reveal(`.testimonial .container` , {origin: 'bottom'})
sr.reveal(`.faq .ask` , {origin: 'left', interval: 100})
sr.reveal(`.recommendations .req` , {origin: 'right', interval: 100})
sr.reveal(`.controls .item` , {origin: 'right', interval: 100})
sr.reveal(`.bookImg` , {origin: 'left'})
sr.reveal(`.room1 img` , {origin: 'left'})
sr.reveal(`.room2 img` , {origin: 'right'})
sr.reveal(`.rest .banner` , {origin: 'bottom'})